import React from 'react'
import styled from 'styled-components'
import { Container } from '@mui/material'
import ErrImg from '../assets/Error-Illustration.svg'
import { Link } from 'react-router-dom'

const containerStyles = {
  background: '#25233B',
  paddingLeft: '0px !important',
  paddingRight: '0px !important',
  borderRadius: '20px',
  height: '100vh',
  '@media (min-width: 901px) and (max-width: 1349px)': {
    paddingLeft: '10%',
    maxWidth: '84%',
    paddingRight: '15%'
  },

  '@media (min-width: 1350px)': {
    width: '1296px',
    maxWidth: '1296px',
    margin: 'auto',
    justifyContent: 'center',
    paddingTop: '24px',
    paddingLeft: '12px'

  },
  '@media (min-width: 0px) and (max-width: 600px)': {
    height: '85vh'
  },
  '@media (min-width: 601px) and (max-width: 900px)': {
    height: '91vh'
  }
}

const Title = styled.div`
  font-family: 'AeonikPro-Medium';
  font-style: normal;
  font-weight: 400;
  font-size: 60px;
  line-height: 72px;
  color: #FFFFFF;
  @media (min-width: 0px) and (max-width: 600px) {
    font-weight: 400;
    font-size: 40px;
    line-height: 48px;
  }
`

const SubTitle = styled.div`
  margin-top: 16px;
  font-family: 'AeonikPro-Regular';
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 35px;
  color: #FFFFFF;
  flex: none;
  order: 1;
  flex-grow: 0;
  @media (min-width: 0px) and (max-width: 600px) {
    font-weight: 400;
    font-size: 18px;
    line-height: 27px;
  }

`

const Main = styled.div`
  background: #25233B
`

const Body = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: 147px;
  @media (min-width: 901px) and (max-width: 1349px) {
    justify-content: space-around;
  }
  @media (min-width: 601px) and (max-width: 900px) {
    padding-top: 0px;
    flex-direction: column-reverse;
  }
  @media (min-width: 0px) and (max-width: 600px) {
    padding-top: 20px;
    flex-direction: column-reverse;
  }

`
const TextContainer = styled.div`
  width: 513px;
  margin-top: 59px;
  @media (min-width: 901px) and (max-width: 1349px) {
    width: 45%;
  }
  @media (min-width: 601px) and (max-width: 900px) {
    margin: 0px auto;
    text-align: center;
  }
  @media (min-width: 0px) and (max-width: 600px) {
    margin: 0px auto;
    text-align: center;
    width: 79%;
  }
`

const ButtonStyle = styled.div`
  margin-top: 36px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 190px;
  height: 52px;
  background: #FF6B18;
  border-radius: 4px;
  color: white;
  font-family: 'AeonikPro-Regular';
  @media (min-width: 601px) and (max-width: 900px) {
    margin: 36px auto;
  }
  @media (min-width: 0px) and (max-width: 600px) {
    margin: 59px auto;
  }
`

const ImgConatiner = styled.img.attrs(() => ({
  src: ErrImg
}))`
  width: 554px;
  height: 429px;
  @media (min-width: 601px) and (max-width: 900px) {
    margin: 81px auto 84px;
    width: 453px;
    height: 351px;
  }
  @media (min-width: 0px) and (max-width: 600px) {
    margin: 52px auto 48px;
    width: 301px;
    height: 233px;
  }
  `

const NotFound = () => {
  return (
    <Main>
      <Container sx={containerStyles}>
        <Body>
          <TextContainer>
            <Title>This page is lost in cyberspace</Title>
            <SubTitle>We can’t find the page you’re looking for. We’re looking high and low for it, but it must be really high up there. </SubTitle>
            <Link style ={{ textDecoration: 'none' }} to={'/'}><ButtonStyle>Back</ButtonStyle></Link>
          </TextContainer>
          <ImgConatiner></ImgConatiner>
        </Body>
      </Container>
    </Main>
  )
}

export default NotFound
